import {Fragment} from 'react/jsx-runtime'
import {Outlet} from 'react-router-dom'
import {ProjectsTabs} from '@/features/projects/components/projects-tabs/ProjectsTabs'

export const ProjectsLayout = () => {
    return (
        <Fragment>
            <ProjectsTabs />
            <Outlet />
        </Fragment>
    )
}
